export class SocieteFormeJuridique {
  public id: number;
  public description?: string;
  public aliases?: string;
  public typePersonne?: string;
}
